import { Component, OnInit } from '@angular/core';
import { SideBarMenuService } from '../services/sidebar-menu.service';
import { LayoutService } from './service/app.layout.service';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {
  model: any[] = [];
  constructor(
    public layoutService: LayoutService,
    private sideBarMenuService: SideBarMenuService,
  ) {}

  ngOnInit() {
    this.model = [
      {
        label: 'Backoffice',
        items: [
          {
            label: 'Apps mobile',
            icon: 'pi pi-fw pi-mobile',
            routerLink: ['/'],
            command: () => this.sideBarMenuService.clearSessionStorage(),
          },
        ],
      },
    ];

    if (localStorage.getItem('appId')) {
      this.model[0].items.push({
        label: 'Clínicas',
        icon: 'pi pi-fw pi-building',
        routerLink: ['/clinics'],
      });
      this.model[0].items.push({
        label: 'Especialistas',
        icon: 'pi pi-fw pi-users',
        routerLink: ['/specialists'],
      });
    }

    this.sideBarMenuService.linkClicked$.subscribe(() => {
      this.model[0].items.push({
        label: 'Clínicas',
        icon: 'pi pi-fw pi-building',
        routerLink: ['/clinics'],
      });
      this.model[0].items.push({
        label: 'Especialistas',
        icon: 'pi pi-fw pi-users',
        routerLink: ['/specialists'],
      });
      //   this.model[0].items.push({
      //     label: 'Usuarios',
      //     icon: 'pi pi-fw pi-users',
      //     routerLink: ['/users'],
      //   });
    });

    this.sideBarMenuService.clearSource$.subscribe(() => {
      this.model = [
        {
          label: 'Backoffice',
          items: [
            {
              label: 'Apps mobile',
              icon: 'pi pi-fw pi-mobile',
              routerLink: ['/'],
              command: () => this.sideBarMenuService.clearSessionStorage(),
            },
          ],
        },
      ];
    });
  }
}
